import BKRIcon from "src/assets/BKRIcon.svg?react";
import { getDefaultBKRCKI } from "src/connections/connectionConfigs/bkr/bkrResources";
import { BKRTemplate } from "src/connections/connectionConfigs/bkr/bkrTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const BKR_CONFIG: ConnectionConfig<"bkr"> = {
  icon: BKRIcon,
  description:
    "Provider of consumer credit and loan information in the Netherlands",
  template: BKRTemplate,
  name: "Netherlands | BKR",
  resources: {
    bkr_cki: {
      externalLink:
        "https://docs.taktile.com/third-party-connections/built-in-connection-nodes/credit-bureaus/bkr#cki-toetsing",
      integrationResource: getDefaultBKRCKI,
    },
  },
};
